export const DashboardIcon = () => {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" width="28" height="28">
      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
    </svg>
  );
};

export const DataSourceIcon = () => {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" width="28" height="28">
      <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z" />
    </svg>
  );
};

export const MappingIcon = () => {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" width="28" height="28">
      <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3.9,19 5,18.1 5,17V5H19M21,7H7A2,2 0 0,0 5,9V21A2,2 0 0,0 7,23H21A2,2 0 0,0 23,21V9A2,2 0 0,0 21,7Z" />
    </svg>
  );
};
